import { createAction, props } from '@ngrx/store';

import { ACTIONS_SCOPE } from './announcement-api.actions';

export const load = createAction(
	`${ ACTIONS_SCOPE } Load`,
	props<{ id: string }>(),
);
